// extracted by mini-css-extract-plugin
module.exports = {"container":"_2bEeEQNpv9yvXBBvEmpfOH orderMainContainer","mobileMarginTop":"_1Y1ns8DNZhwPZ5az9jD21B","loadingContainer":"_3-H9UEsWuWJy9oTqpF_DKH"};